import { internal, template } from '../../../vendor/elix.js';

function ButtonOutlinedMixin(Base) {

  return class ButtonOutlined extends Base {

      get [internal.template]() {

        return template.concat(

          super[internal.template],

          template.html`
            <style>
 
              #inner {
                color: var(--tp-button-outlined-mixin-font-color);
                border: 2px solid var(--tp-button-outlined-mixin-border-color);
                background-color: var(--tp-button-outlined-mixin-background-color);
                line-height: 0;
              }
      
              #inner[disabled], #inner:disabled {
                border: 2px solid var(--tp-button-outlined-mixin-border-color-disabled);
                color: var(--tp-button-outlined-mixin-font-color-disabled);
                background-color: var(--tp-button-outlined-mixin-background-color-disabled);
              }
      
              #inner:hover:enabled,
              #inner:active:enabled,
              :host(:focus) #inner:enabled {
                background-color: var(--tp-button-outlined-mixin-background-color-active);
              }
             
            </style>
          `
        );
      }
    }
  }

export default ButtonOutlinedMixin;
